import {
  AlertTriangle,
  ArrowDownToLine,
  BarChart3,
  Boxes,
  Building2,
  Cable,
  ClipboardCheck,
  Cog,
  Cylinder,
  Download,
  Factory,
  Flame,
  FlaskConical,
  Forklift,
  Gauge,
  Gift,
  GitCompare,
  GraduationCap,
  Hand,
  HardHat,
  HeartPulse,
  Layers,
  LayoutGrid,
  Library,
  ListChecks,
  MoveVertical,
  Package,
  PersonStanding,
  Presentation,
  Printer,
  Route,
  Ruler,
  ScanSearch,
  Settings2,
  ShieldCheck,
  Siren,
  Target,
  Warehouse,
  Wind,
  Zap,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Professional Visual Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: 'Ready-to-Teach Training Resources', icon: Presentation, featured: true },
  { label: 'Workplace Hazard Identification', icon: ScanSearch },
  { label: 'Risk Assessment Concepts', icon: Gauge },
  { label: 'Hazard Classification Diagrams', icon: AlertTriangle },
  { label: 'Hierarchy of Controls', icon: Layers },
  { label: 'Warehouse Traffic', icon: Warehouse },
  { label: 'Forklift Awareness', icon: Forklift },
  { label: 'Material Handling Safety', icon: Package },
  { label: 'Workplace Storage Hazards', icon: LayoutGrid },
  { label: 'Machinery Safety Fundamentals', icon: Cog },
  { label: 'Machine Guarding Concepts', icon: ShieldCheck },
  { label: 'Conveyor Systems', icon: Route },
  { label: 'Industrial Gears', icon: Settings2 },
  { label: 'Mechanical Pinch Points', icon: Hand },
  { label: 'Hazardous Energy Awareness', icon: Zap },
  { label: 'Electrical Safety Awareness', icon: Cable },
  { label: 'Hydraulic System Diagrams', icon: Cylinder },
  { label: 'Pneumatic Energy Concepts', icon: Wind },
  { label: 'Fire Hazard Recognition', icon: Flame },
  { label: 'Emergency Preparedness', icon: Siren },
  { label: 'Fall Hazard Identification', icon: ArrowDownToLine },
  { label: 'Ladder Awareness', icon: MoveVertical },
  { label: 'Working at Height', icon: Building2 },
  { label: 'PPE Training Resources', icon: HardHat },
  { label: 'Chemical Hazard Awareness', icon: FlaskConical },
  { label: 'Occupational Health Concepts', icon: HeartPulse },
  { label: 'Ergonomics', icon: PersonStanding },
  { label: 'Industrial Technical Illustrations', icon: Ruler },
  { label: 'Realistic Workplace Scenarios', icon: Factory },
  { label: 'Correct-versus-Incorrect Comparisons', icon: GitCompare },
  { label: 'Hazard Identification Exercises', icon: Target },
  { label: 'Instructor Teaching Resources', icon: GraduationCap },
  { label: 'Classroom Knowledge Checks', icon: ListChecks },
  { label: 'Student Assessment Tools', icon: ClipboardCheck },
  { label: 'Beginner-to-Advanced Activities', icon: BarChart3 },
  { label: 'Printable Reference Materials', icon: Printer },
  { label: '5 Exclusive Professional Bonuses', icon: Gift, featured: true },
  { label: 'Immediate Digital Access', icon: Download },
]
